import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AboutGuard } from './guards/about.guard';
import { ExposesGuard } from './guards/exposes.guard';
import { FavoriteGuard } from './guards/favorite.guard';
import { ProfileGuard } from './guards/profile.guard';
import { ArchiveGuard } from './guards/archive.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomeModule)
  },
  {
    path: 'article/:slug',
    loadChildren: () => import('./pages/detail/detail-module').then( m => m.DetailModule)
  },
  {
    path: 'exposes-detail/:newspaper/:slug',
    loadChildren: () => import('./pages/factsheetdetail/factssheetdetail.module').then( m => m.FactSheetDetailModule)
  },
  {
    path: 'changer-mot-de-passe/:token',
    loadChildren: () => import('./pages/password-reset/password-reset.module').then( m => m.PasswordResetModule)
  },
  {
    path: 'page/:slug',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactModule)
  },
  {
    path: 'changer-mot-de-passe-parent/:token',
    loadChildren: () => import('./pages/reset-password-parent/reset-password-parent.module').then( m => m.ResetPasswordParentModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuModule)
  },
  {
    path: 'exposes',
    canLoad: [ExposesGuard],
    loadChildren: () => import('./pages/exposes/exposes.module').then( m => m.ExposesModule)
  },
  {
    path: 'dossiers-actualite',
    loadChildren: () => import('./pages/thematicfiles/thematicfiles.module').then( m => m.ThematicfilesModule)
  },
  {
    path: 'connexion',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginModule)
  },
  {
    path: 'creer-profil',
    loadChildren: () => import('./pages/addprofile/addprofile.module').then( m => m.AddProfileModule)
  },
  {
    path: 'connexion/oubli-mot-de-passe',
    loadChildren: () => import('./pages/forgotpassword/forgotpassword.module').then( m => m.ForgotPasswordModule)
  },
  {
    path: 'pdf',
    canActivate: [ArchiveGuard],
    loadChildren: () => import('./pages/archives/archives.module').then( m => m.ArchivesModule)
  },
  {
    path: 'actu-livres',
    loadChildren: () => import('./pages/actu-livres/actu-livres.module').then( m => m.ActuLivresModule)
  },
  {
    path: 'editer-profil',
    loadChildren: () => import('./pages/edit-profile/edit-profile.module').then( m => m.EditProfileModule)
  },
  {
    path: 'creer-compte',
    loadChildren: () => import('./pages/account-creation/account-creation.module').then(m => m.AccountCreationModule)
  },
  {
    path: 'offres',
    loadChildren: () => import('./pages/offers/offers.module').then( m => m.OffersModule)
  },
  {
    path: 'cas_login/:token',
    loadChildren: () => import('./pages/cas-login/cas-login.module').then( m => m.CasLoginModule)
  },
  {
    path: 'hds-connexion-ent',
    loadChildren: () => import('./pages/gar-login/gar-login.module').then( m => m.GarLoginModule)
  },
  {
    path: 'ena78-connexion',
    loadChildren: () => import('./pages/gar-login/gar-login.module').then( m => m.GarLoginModule)
  },
  {
    path: 'kne-login',
    loadChildren: () => import('./pages/kne-login/kne-login.module').then( m => m.KneLoginModule)
  },
  {
    path: 'ajouter-code-gratuit',
    loadChildren: () => import('./pages/apply-coupon/apply-coupon.module').then( m => m.ApplyCouponPageModule)
  },
  {
    path: 'merci',
    loadChildren: () => import('./pages/signinthankyou/signinthankyou.module').then( m => m.SignInThankYouModule)
  },
  {
    path: 'favoris',
    canLoad: [FavoriteGuard],
    loadChildren: () => import('./pages/favorites/favorites.module').then( m => m.FavoritesModule)
  },
  {
    path: 'club-des-lecteurs/desinscription',
    loadChildren: () => import('./pages/unsubscribe/unsubscribe.module').then( m => m.UnsubscribeModule)
  },
  {
    path: 'connexion-profil',
    loadChildren: () => import('./pages/profiles/profiles.module').then( m => m.ProfilesModule),
    canLoad: [ProfileGuard]
  },
  {
    path: 'profiles',
    loadChildren: () => import('./pages/profiles/profiles.module').then( m => m.ProfilesModule),
    canLoad: [ProfileGuard]
  },
  {
    path: 'about',
    canLoad: [AboutGuard],
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutModule)
  },
  {
    path: 'loginprofile',
    loadChildren: () => import('./pages/loginprofile/loginprofile.module').then( m => m.LoginProfileModule)
  },
  {
    path: 'profileeditor',
    loadChildren: () => import('./pages/profile-editor/profile-editor.module').then( m => m.ProfileEditorModule)
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes , { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
